var map = {
	"./blot-blue.png": 6041,
	"./blot-orange.png": 3371,
	"./capital.jpg": 1957,
	"./cleaning.jpg": 4564,
	"./current.jpg": 8262,
	"./degasification.jpg": 3369,
	"./filling.jpg": 6287,
	"./install.jpg": 5340,
	"./old/cleaning.jpg": 2834,
	"./old/degasification.jpg": 7943,
	"./old/filling.jpg": 7074,
	"./old/regeneration.jpg": 5150,
	"./old/replacement.jpg": 2719,
	"./old/topping.jpg": 826,
	"./regeneration.jpg": 4576,
	"./replacement.jpg": 1185,
	"./to.jpg": 4618,
	"./topping.jpg": 4212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6601;